import createClient from 'openapi-fetch';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
});

export async function listConfigs() {
    const { data, error } = await client.GET('/super_admin/referral/configs');
    if (error) {
        throw new Error(error?.detail || 'خطا در دریافت تنظیمات');
    }
    return data || [];
}

export async function createConfig(payload) {
    const { data, error } = await client.POST('/super_admin/referral/configs', {
        body: payload,
    });
    if (error) {
        const detail = error?.detail;
        const message = Array.isArray(detail)
            ? detail.map((i) => i.msg || JSON.stringify(i)).join(' | ')
            : typeof detail === 'string'
                ? detail
                : 'خطا در ایجاد تنظیمات';
        throw new Error(message);
    }
    return data;
}

export async function updateConfig(configId, payload) {
    const { data, error } = await client.PATCH(
        `/super_admin/referral/configs/${configId}`,
        { body: payload }
    );
    if (error) {
        const detail = error?.detail;
        const message = Array.isArray(detail)
            ? detail.map((i) => i.msg || JSON.stringify(i)).join(' | ')
            : typeof detail === 'string'
                ? detail
                : 'خطا در ویرایش تنظیمات';
        throw new Error(message);
    }
    return data;
}

export async function activateConfig(configId) {
    const { data, error } = await client.POST(
        `/super_admin/referral/configs/${configId}/activate`
    );
    if (error) {
        throw new Error(error?.detail || 'خطا در فعال‌سازی تنظیمات');
    }
    return data;
}

export async function deleteConfig(configId) {
    const { error } = await client.DELETE(
        `/super_admin/referral/configs/${configId}`
    );
    if (error) {
        throw new Error(error?.detail || 'خطا در حذف تنظیمات');
    }
    return true;
}